import { Link, NavLink, useNavigate } from 'react-router-dom';
import { signOut } from '../lib/auth';
import type { Session } from '../lib/supabase';

interface Props {
  session: Session;
  children: React.ReactNode;
}

export default function Layout({ session, children }: Props) {
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white border-bottom">
        <div className="container-fluid px-4">
          <Link to="/" className="navbar-brand navbar-brand-bb">
            <i className="bi bi-clipboard2-pulse-fill me-2" />
            BebêCare · Admin
          </Link>

          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <NavLink to="/" end className="nav-link">
                Dashboard
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/waitlist" className="nav-link">
                Waitlist
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/practices" className="nav-link">
                Consultórios
              </NavLink>
            </li>
          </ul>

          <div className="d-flex align-items-center gap-3">
            <span className="small text-muted">{session.user.email}</span>
            <button
              type="button"
              onClick={handleLogout}
              className="btn btn-sm btn-outline-secondary"
            >
              <i className="bi bi-box-arrow-right me-1" />
              Sair
            </button>
          </div>
        </div>
      </nav>

      <main className="container-fluid px-4 py-4">{children}</main>
    </>
  );
}
